import { injector } from "../dependencies/injector";
import { APP_SERVICE, AppService } from "../services/app.service";

/** Default lang used for cervval.js */
export const DEFAULT_LANG = "fr";

// fr or en languages
export type Lang_fr_en = "fr" | "en"

// Default available language or other custom string language
export type Lang = Lang_fr_en | string

/**
 * @returns the default lang registered in the App Service
 */
export function getDefaultLang(): Lang {
    return injector.find<AppService>(APP_SERVICE)?.lang ?? DEFAULT_LANG;
}